import React from 'react'
import { Group, Rect, Text } from 'react-konva'
import { useEditorStore, PPM } from '../../store/editorStore'
import type { StructuralGeometry, StructuralGeometryKind } from '../../utils/structuralGeometry.logic'

const COLORS: Record<StructuralGeometryKind, { fill: string; stroke: string; label: string }> = {
  wall: { fill: '#64748b', stroke: '#cbd5e1', label: 'Стена' },
  door: { fill: '#d97706', stroke: '#fbbf24', label: 'Дверь' },
  column: { fill: '#52525b', stroke: '#d4d4d8', label: 'Колонна' },
  restricted_zone: { fill: '#991b1b', stroke: '#f87171', label: 'Restricted zone' },
  boundary: { fill: '#334155', stroke: '#94a3b8', label: 'Граница' },
}

function metricValue(structure: StructuralGeometry, camel: keyof StructuralGeometry, snake: keyof StructuralGeometry) {
  return Number(structure[camel] ?? structure[snake] ?? 0)
}

export const StructuralGeometryLayer: React.FC = () => {
  const structures = useEditorStore(state => state.dcSettings.structuredGeometry)
  const selectedIds = useEditorStore(state => state.selectedIds)
  const toggleSelected = useEditorStore(state => state.toggleSelected)

  return (
    <Group listening>
      {structures.map(structure => {
        const width = metricValue(structure, 'widthM', 'width_m') * PPM
        const height = metricValue(structure, 'depthM', 'depth_m') * PPM
        const x = metricValue(structure, 'xM', 'x_m') * PPM
        const y = metricValue(structure, 'yM', 'y_m') * PPM
        const style = COLORS[structure.kind]
        const selected = selectedIds.includes(structure.id)
        return (
          <Group
            key={structure.id}
            x={x + width / 2}
            y={y + height / 2}
            rotation={structure.rotation ?? 0}
            onClick={event => toggleSelected(structure.id, Boolean((event.evt as MouseEvent).shiftKey))}
            onTap={event => toggleSelected(structure.id, Boolean((event.evt as MouseEvent).shiftKey))}
          >
            <Rect
              x={-width / 2}
              y={-height / 2}
              width={width}
              height={height}
              fill={style.fill}
              opacity={structure.kind === 'restricted_zone' ? 0.24 : 0.82}
              stroke={selected ? '#f8fafc' : style.stroke}
              strokeWidth={selected ? 3 : 1.5}
              dash={structure.kind === 'restricted_zone' ? [8, 5] : undefined}
            />
            {width > 40 && height > 20 && (
              <Text
                x={-width / 2 + 4}
                y={-height / 2 + 4}
                width={Math.max(0, width - 8)}
                text={style.label}
                fontSize={11}
                fill="#f8fafc"
                listening={false}
              />
            )}
          </Group>
        )
      })}
    </Group>
  )
}
